







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class ProductMainAddIframe extends Vue {
  private get pageType() {
    return this.$route.name === 'ProductSectionAdd' ? 'add' : 'edit';
  }

  private get pageTitle() {
    switch (this.pageType) {
      case 'add':
        return '등록';
      case 'edit':
        return '수정';
      default:
        return '등록';
    }
  }

  private get remoteSrc() {
    const url = `/appearance/custom/product-main/${this.pageType}?`;
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + url + queryString;

    return src;
  }
}
